import { useTranslation } from 'react-i18next'
import DebugScheduledDownloads from './DebugScheduledDownloads'
import RefetchLocalDatabase from './RefetchLocalDatabase'
import { Root } from '../../../models3/Root'
import { useAppRoot } from '../../app/RootContext'
import VideoCacheResetRequest from './VideoCacheResetRequest'
import { AllMissingRecordingsTable } from '../../utils/MissingRecordings'

interface DownloadReportProps {
    rt: Root
}

export const DownloadReport = ({ rt }: DownloadReportProps) => {
    const appRoot = useAppRoot()
    const { t } = useTranslation()
    return (
        <div>
            <AllMissingRecordingsTable rt={rt} header={<h3>{t('missingRecordingsHeader')}</h3>} />
            <DebugScheduledDownloads rt={rt} />
            {localStorage.getItem('debugDownloads') && (
                <>
                    <VideoCacheResetRequest />
                    <RefetchLocalDatabase appRoot={appRoot} />
                </>
            )}
        </div>
    )
}
